import React from "react";
import { useSelector } from "react-redux";

const HideForManager = ({ children, fallback = null }) => {
    const role = useSelector((state) => state?.profileData?.role);

    if (Number(role) !== 1) return fallback;

    return <>{children}</>;
};

export default HideForManager;